<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'

import executeButtonService from '@/services/embeds/plugin/execute.button.service'
import executeService from '@/services/embeds/plugin/execute.service'
import { useIdeStore } from '@/stores/embeds/ide.store'

const ideStore = useIdeStore()

const { isCodeExecuting } = storeToRefs(ideStore)

/**
 * Tries to execute the code
 */
const tryExecute = () => {
  executeService.tryExecute()
}
/**
 * Stops the execution
 */
const stopExecution = () => {
  executeService.stopExecution()
}

onMounted(async () => {
  await new Promise((resolve) => setTimeout(resolve, 100))
  executeButtonService.initExecuteBtn()
})
onBeforeUnmount(async () => {
  executeButtonService.destroyExecuteBtn()
  await new Promise((resolve) => setTimeout(resolve, 100))
})
</script>

<template>
  <div class="flex h-full w-full justify-center gap-2">
    <button
      id="execute-embeds"
      v-if="!isCodeExecuting"
      class="flex w-fit min-w-fit justify-center rounded-md p-2 font-semibold leading-6 outline-none"
      @click="tryExecute"
    >
      <div class="flex gap-2">
        <span>Execute</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          width="24"
          viewBox="0 0 384 512"
          fill="currentColor"
        >
          <path
            d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"
          />
        </svg>
      </div>
    </button>
    <button
      v-if="isCodeExecuting"
      class="flex w-fit min-w-fit justify-center rounded-md p-2 font-semibold leading-6 outline-none"
      @click="stopExecution"
    >
      <div class="flex gap-2">
        <span> Stop Execution</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          width="24"
          viewBox="0 0 384 512"
          fill="currentColor"
        >
          <path
            d="M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
          />
        </svg>
      </div>
    </button>
  </div>
</template>
